import React from 'react'
import LocalStorage from '../../local_storage/LocalStorage'
import debug from '../../utils/debugging'
const AppCtx = React.createContext()

class AppContext extends React.Component {
	constructor(props) {
		super(props)
		this.user = null // no user info yet
		this.actions = {
			// setApplications: this.setApplications,
			signUpUser: this.signUpUser,
			setCurrentUser: this.setCurrentUser,
			signOutUser: this.signOutUser,
			setAutoPlayAudio: this.setAutoPlayAudio,
			setMustStayInGame: this.setMustStayInGame 
		}
		this.state = {
			apps: null, // arr of apps for sell
			component_mounted: false,
			mounted: false,
			user: null,
			users: {},
			must_stay_in_game: false,
		}

	}
	// ------------------------------------- Context Buisness ------------------------------------
	setApplications = (data) => {
		this.setState({ apps: data })
	}

	setMustStayInGame = (bool) => this.setState({ must_stay_in_game: bool })

	/**
	 * Sets the contexts user state to the current user form the locally stored users object
	 * use this method to set a user after it has been authenticated
	 * @param {string} agent_name
	 */
	setCurrentUser = (agent_name) => {
		debug.log('set current user', agent_name)
		const users = LocalStorage.get('users')
		// TODO handle fails
		LocalStorage.set('current_user', agent_name)
		this.setState({ user: users[agent_name] })
	}

	signUpUser = (user_data) => {
		debug.log('signing up user appctx')
		// add user_data to list of users
		LocalStorage.addOnObject('users', { [user_data.agent_name]: user_data })
		this.setCurrentUser(user_data.agent_name)
	}

	signOutUser = () => {
		LocalStorage.set('current_user', null)
		this.setState({ user: null })
	}

	setAutoPlayAudio = bool => {
		const updated_user = LocalStorage.getCurrentUser()
		updated_user.auto_play_audio = bool
		LocalStorage.updateUserData(updated_user)
		this.setState({ user: updated_user })
		debug.log('setAutoPlayAudio', updated_user)
	}
	// ------------------------------------- Render Method ----------------------------------------
	componentDidCatch() { }
	componentDidMount = () => {
		// load the user
		const user_id = LocalStorage.get('current_user')
		const users = LocalStorage.get('users') || {}
		this.setState({
			user: users[user_id],
			mounted: true
		})

	}

	render() {
		if (!this.state.mounted) {
			return <p>Loading</p>
		}
		debug.log('ctx render: user', this.state.user)
		return (
			<AppCtx.Provider value={{ ...this.state, ...this.actions }}>
				{this.props.children}
			</AppCtx.Provider>)
	}

}

export { AppContext }
export default AppCtx
